import { parseReferralCodePayload } from "./urlParams";

/** Legacy buxusweb `Utils.isValidEmail` parity. */
const INVITE_EMAIL_RE = /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

export function isValidInviteEmail(email: string): boolean {
  return INVITE_EMAIL_RE.test(email.trim());
}

/** Split comma- or newline-separated invite list (legacy InviteForm). */
export function parseInviteEmailList(raw: string): string[] {
  return raw
    .split(/[,\n]+/)
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
}

export function validateInviteEmailList(raw: string): {
  emails: string[];
  error: string | null;
} {
  const emails = parseInviteEmailList(raw);
  if (emails.length === 0) {
    return { emails: [], error: "Please enter one or more email addresses." };
  }
  if (!emails.every(isValidInviteEmail)) {
    return { emails, error: "One or more email addresses are invalid." };
  }
  return { emails, error: null };
}

export type InviteUrlParams = {
  referralCode: string | null;
  referrerContactId: string | null;
};

/** Parse `/user/invite?referralCode=…` (mobile Profile → WebView). */
export function parseInviteUrlParams(search: string): InviteUrlParams {
  const q = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const referralRaw = (q.get("referralCode") ?? "").trim();
  if (!referralRaw) {
    return { referralCode: null, referrerContactId: null };
  }
  const parsed = parseReferralCodePayload(referralRaw);
  return {
    referralCode: referralRaw,
    referrerContactId: parsed?.referrerContactId ?? null,
  };
}
